import React from "react";

const CustomSelect = ({
  value,
  onChange,
  children,
  className = "",
  disabled = false,
}) => {
  return (
    <div className="custom-select-wrapper">
      <select
        className={`custom-select ${className}`}
        value={value}
        onChange={onChange}
        disabled={disabled}
      >
        {children}
      </select>

      <span className="select-arrow">▼</span>
    </div>
  );
};

export default CustomSelect;